import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { BarrelOwnerCrudService } from 'src/app/shared/services/barrel-owner-crud.service';
import { BarrelOwner  } from 'src/app/shared/interfaces/barrel-owner';


@Component({
  selector: 'app-owners',
  templateUrl: './owners.component.html',
  styleUrls: ['./owners.component.scss']
})
export class OwnersComponent implements OnInit {

  
  owners: BarrelOwner[];
  owner: BarrelOwner;
  selectedOwners: BarrelOwner[] = [];

  ownerDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private ownerService : BarrelOwnerCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Barrel Management'},
      {label: 'Owners'}
    ];

    this.owners = [];
    this.owner = { } as BarrelOwner ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.ownerService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.owners = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : BarrelOwner = jsonItem as BarrelOwner;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.owners.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    //this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.ownerService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.owners);
            doc.save('owners.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.owners);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "owners");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        console.log('SAVEC CSV COL F ',sc.field);
        console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedOwners);
      console.log('SAVEC CSV LOCATIONS ', this.owners);
      console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedOwners, 'owners', exportCols);
   // this.exportService.exportToCsv(this.owners, 'owners', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.owner = {} as BarrelOwner;
    this.submitted = false;
    this.ownerDialog = true;
  }

  deleteSelectedOwners() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected owners?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.owners = this.owners.filter(val => !this.selectedOwners.includes(val));
            
            this.selectedOwners.forEach( owner => this.ownerService.delete(owner.$key));
            this.selectedOwners = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Ownerss Deleted', life: 3000});
        }
    });
  }

  editOwner(owner: BarrelOwner) {
    this.owner = {...owner};
    this.ownerDialog = true;
  }

  deleteOwner(owner: BarrelOwner) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + owner.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.owners = this.owners.filter(val => val.$key !== owner.$key);
            this.owner = {} as BarrelOwner;
            this.ownerService.delete(owner.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Owner Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.ownerDialog = false;
    this.submitted = false;
  }

  saveOwner() {
    this.submitted = true;

    if ( this.owner.name.trim() ) {
      this.owner.isEnabled = true;
      
      if (this.owner.$key) {
          this.owners[this.findIndexById(this.owner.$key)] = this.owner;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Owner Updated', life: 3000});
          this.ownerService.update(this.owner);
        } else {
          this.owner.position = this.owners.length;
          this.ownerService.add(this.owner);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Owner Created', life: 3000});
      this.owners = [...this.owners];
    }

    this.ownerDialog = false;
    this.owner = { } as BarrelOwner;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.owners.length; i++) {
        if (this.owners[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeOwner(owner : BarrelOwner) {
    //console.log("SAVE", owner);
    this.ownerService.update(owner);
  }

  completePosition(owner : BarrelOwner) {
    console.log("SAVE", owner);
  //  this.ownerService.updateOwner(owner);


    if ( this.newPosition > -1 ) {
        owner.position = this.newPosition;
        owner = this.checkPositionLimits(owner);
        this.reorderElements(owner);
        //this.updateDB(spray);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.sprays);
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.owners.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.owners.length - 1 - event.dropIndex;
    const sprayToMove = this.owners[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.owners[index] = this.owners[index+1];
        this.owners[index].position = index;
        this.ownerService.update(this.owners[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.owners[index] = this.owners[index-1];
        this.owners[index].position = index;
        this.ownerService.update(this.owners[index]);
      }
    } 
    this.owners[endIndex] = sprayToMove;
    this.owners[endIndex].position = endIndex;
    this.ownerService.update(this.owners[endIndex]);
  }

  // onFieldEdit(spray: Spray, fieldName: string): void {
  //   //console.log(this.sprays);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + spray[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       spray.position = this.newPosition;
  //       spray = this.checkPositionLimits(spray);
  //       this.reorderElements(spray);
  //       //this.updateDB(spray);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(spray);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.owners.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, spray: BarrelOwner) {
    console.log("event" +event);
    if (spray.position != null && spray.position > -1) {
      this.previousPosition = spray.position;
      this.newPosition = event;
    }
   
    console.log("previous" +this.previousPosition);
    console.log("new" +this.newPosition);
  }

  checkPositionLimits(spray: BarrelOwner) {
    console.log('check ',spray.position + ' ' + this.owners.length);
    if (!spray.position) {
      console.log('check 1');
      return this.owner;
    }
    if (spray.position < 0) {
      spray.position = 0;
      console.log('check 2');
      return spray;
    }
    if (spray.position > this.owners.length) {
      spray.position = this.owners.length - 1;
      console.log('check 3', spray.position);
      return spray;
    }
    console.log('check 4');
    return spray;
  }

  async reorderElements(spray: BarrelOwner) {
    this.newPosition = this.newPosition  > this.owners.length ? this.owners.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === spray.position ) {
      return;
    }
    console.log('Previous position: '+ this.previousPosition);
    console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const sprayToMove = this.owners[startIndex];
    console.log('Item to move: ', this.owners[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.owners);
        console.log('Item to +1: ', this.owners[index+1]);

        this.owners[index] = this.owners[index+1];
        this.owners[index].position = index;
        console.log('Move: ', this.owners[index+1]);
        console.log('Move pos: ', this.owners[index].position);
        //await this.updateDB(this.sprays[index]);
        this.ownerService.update(this.owners[index]);
        console.log('Update DB: ', this.owners[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.owners[index] = this.owners[index-1];
        this.owners[index].position = index;
        this.ownerService.update(this.owners[index]);
      }
    } 
    this.owners[endIndex] = sprayToMove;
    this.owners[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.ownerService.update(this.owners[endIndex]);
    
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.sprays = myClonedArray;
   // this.getAllRecords();
  }

}
